import { useState } from 'react';
import { format } from 'date-fns';
import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export function useExportCsv(templateType, filenamePrefix, errorToastId) {
    const { t: commonTexts } = useLocaleKeys('common');
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const { downloadCsv } = useIoContext();
    const { showErrorToast } = useOverlayContext();
    const [exportingCsv, setExportingCsv] = useState(false);
    async function handleExportCsv() {
        if (businessId == null) {
            return;
        }
        setExportingCsv(true);
        try {
            const csvString = await api.serviceTemplate.exportServiceTemplatesToCsv(businessId, templateType);
            downloadCsv(csvString, filenamePrefix + format(new Date(), 'yyyy-MM-dd') + '.csv');
        } catch (unused) {
            showErrorToast(commonTexts.toasts.errorExportingToCsv(), errorToastId);
        } finally{
            setExportingCsv(false);
        }
    }
    return {
        exportingCsv,
        handleExportCsv
    };
}
